import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Menu, MenuItem, Box } from '@mui/material';
import { useState, MouseEvent } from 'react';
import { useGetCurrentUser, useSignOut } from '../../../hooks/auth.ts';
import { useDialogs } from '../../../contexts/Dialog/DialogContext.tsx';
import { AuthDialog } from '../../../views/auth-dialog/auth-dialog.tsx';

export const ProfileButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const user = useGetCurrentUser();
  const signOut = useSignOut();

  const dialogs = useDialogs();
  const openAuthDialog = () => {
    dialogs.open(AuthDialog, { payload: 'login' });
    handleClose();
  };

  return (
    <Box sx={{ alignSelf: 'center' }}>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {user.data?.userId ? (
          <Box>
            <MenuItem onClick={() => signOut.mutate()}>Sign out</MenuItem>
          </Box>
        ) : (
          <MenuItem onClick={() => openAuthDialog()}>Sign in</MenuItem>
        )}
      </Menu>
    </Box>
  );
};
